import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './storie-slider.scss';

export class StorieSlider {
  constructor() {
    this.el = document.querySelector('.js-storie-slider');
    if (!this.el) return;

    this.init();
  }

  init() {
    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '1.5rem',
      perPage: 3.5,
      focus: 0,
      trimSpace: true,
      snap: true,
      breakpoints: {
        992: {
          perPage: 2.5,
        },
        767: {
          perPage: 1.5,
        },
      },
      i18n: Translations.getSplideI18n(),
    });

    splide.mount();

    const next = this.el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 992px)').matches) return;
      const { index } = splide;
      const last = splide.length - splide.options.perPage;
      // Se sono all’ultima slide disabilito next
      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    };

    // primo chek al caricamento
    updateArrows();
    // secondo check al cambio slide
    splide.on('mounted move', updateArrows);
  }
}
